/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Kredi_SistemiInputs */

const tr_faq_q_kredi_sistemi = /** @type {(inputs: Faq_Q_Kredi_SistemiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredi sistemi nasıl çalışır?`)
};

const en_faq_q_kredi_sistemi = /** @type {(inputs: Faq_Q_Kredi_SistemiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does the credit system work?`)
};

const de_faq_q_kredi_sistemi = /** @type {(inputs: Faq_Q_Kredi_SistemiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie funktioniert das Credit-System?`)
};

const ru_faq_q_kredi_sistemi = /** @type {(inputs: Faq_Q_Kredi_SistemiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как работает система кредитов?`)
};

/**
* | output |
* | --- |
* | "How does the credit system work?" |
*
* @param {Faq_Q_Kredi_SistemiInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_kredi_sistemi = /** @type {((inputs?: Faq_Q_Kredi_SistemiInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Kredi_SistemiInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_kredi_sistemi(inputs)
	if (locale === "de") return de_faq_q_kredi_sistemi(inputs)
	if (locale === "ru") return ru_faq_q_kredi_sistemi(inputs)
	return tr_faq_q_kredi_sistemi(inputs)
});